import SgiG6Component from './SgiG6Component';

export default class SgiG6Common extends SgiG6Component {


}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiG6/SgiG6Common.js